import React, {Component, useCallback} from 'react';
import request from 'superagent';
import _ from 'lodash';
import Select from 'react-select3';
import {ProgressBar, HelpBlock} from "react-bootstrap";
import PropTypes from 'prop-types';
import {notify} from 'common/Notification';
import classNames from 'classnames';

import './IManageWorkspaceFolderSelector.less';

export default class IManageWorkspaceFolderSelector extends Component {
  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    libraryId: PropTypes.string.isRequired,
    workspaceId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object,
    meta: PropTypes.object,
    parentFolder: PropTypes.object,
    pathToFolder: PropTypes.array,
    subFolders: PropTypes.array,
  };

  static defaultProps = {
    pathToFolder: [],
    subFolders: [],
  };

  state = {
    isLoading: false,
    options: null,
    value: this.props.value,
  };

  componentDidMount() {
    if (!this.state.options)
      this.loadOptions(false);
  }

  // if workspace or parent folder changed, refresh options
  componentDidUpdate(prevProps, prevState, snapshot) {
    const curProps = this.props;

    if ((prevProps.workspaceId !== curProps.workspaceId) || (prevProps.parentFolder !== curProps.parentFolder)) {
      this.loadOptions(false);
    }
  }

  loadOptions(refresh) {
    const {connectionId, libraryId, workspaceId, parentFolder} = this.props;

    const parentType = parentFolder ? 'folder' : 'workspace';
    const parent = parentFolder ? parentFolder.id : workspaceId;

    // if we do not yet have a parent, bail out.  Probably component hasn't received the prop yet
    if (!parent)
      return;

    this.setState({isLoading: true});

    request.get(`/rpc/integrations/connections/${connectionId}/imanage/workspace-folders`)
      .query({
        library: libraryId,
        workspace: workspaceId,
        parent_type: parentType,
        parent,
        refresh
      })
      .then(response => {
        // if the new set of options does not contain the value that was selected, clear it.
        const options = _.get(response, 'body.folders', []);

        // set value to null if the current selected value is not in the new set of options.
        const currentValue = this.state.value;
        const newValue = (currentValue && _.find(options, { id: currentValue.id }))
          ? currentValue
          : null;

        this.setState({isLoading: false, value: newValue, options});
      })
      .catch(error => notify.error("Failed to load iManage workspace folders"));
  }

  refreshOptions = (event) => {
    event.preventDefault();
    this.loadOptions(true);
  };

  onValueChange = (value) => {
   this.setState({value}, () => {
     if (this.props.onChange)
       this.props.onChange(this.currentPathToFolder());
   });
  };

  currentPathToFolder() {
    const {value}        = this.state;
    const {pathToFolder} = this.props;

    if (value)
      return pathToFolder.concat(value);
    else
      return pathToFolder;
  }

  render() {
    const {isLoading, options, value} = this.state;
    const {meta, connectionId, libraryId, workspaceId, parentFolder} = this.props;

    // if we do not yet have the workspaceId, bail out.
    if (!workspaceId)
      return null;

    if (isLoading)
      return <ProgressBar now={100}/>;

    // if this is a sub-folder select and there are no subfolders, do not render anything
    if (parentFolder && options && options.length === 0)
      return null;

    const hasErrors = meta && meta.error && meta.touched;

    const containerClasses = classNames({
      'folder-tree': true,
      'has-error': hasErrors,
    });

    return (
      <div className={containerClasses}>
        <Select
          value={value}
          label={_.get(value, 'name')}
          options={options}
          placeholder="Select folder"
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          onChange={this.onValueChange}
          isClearable
        />
        <a href="#" onClick={this.refreshOptions}>Refresh</a>
        {hasErrors && <HelpBlock>{meta.error}</HelpBlock>}

        {value &&
          <ul>
            <li>
              <IManageWorkspaceFolderSelector
                connectionId={connectionId}
                libraryId={libraryId}
                workspaceId={workspaceId}
                onChange={this.props.onChange}
                parentFolder={value}
                value={_.head(this.props.subFolders)}
                subFolders={_.slice(this.props.subFolders, 1)}
                pathToFolder={this.props.pathToFolder.concat(value)}
              />
            </li>
          </ul>
        }
      </div>
    );
  }
};

// final form compatible component
export const FinalFormIManageWorkspaceFolderSelect = ({input: {value, onChange}, ...rest}) => {
  return (
    <IManageWorkspaceFolderSelector
      onChange={selectedOption => onChange(selectedOption)}
      value={_.head(value)}
      subFolders={_.slice(value, 1)}
      {...rest}
    />
  )
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/iManage/IManageWorkspaceFolderSelector.jsx